import React, { useState } from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Input = styled.input`
  outline: none;
  border: 1px solid #a9aeb9;
  border-radius: 4px;
  height: 26px;
  min-width: 280px;
  max-width: 300px;
  padding: 5px 12px;
  transition: 0.3s linear;
  z-index: 1;
  background: transparent;

  &:focus {
    border: 1px solid #17c95f;
  }

  &::-webkit-input-placeholder {
    opacity: ${({ trigger }) => (trigger ? "1" : "0")};
    transition: 0.3s linear;
  }
`;

const Label = styled.label`
  position: absolute;
  font-size: ${({ trigger }) => (trigger ? "12px" : "14px")};
  font-size: ${({ trigger }) => (trigger ? "12px" : "14px")};
  top: ${({ trigger }) => (trigger ? "-20px" : "5px")};
  left: ${({ trigger }) => (trigger ? "-12px" : "0")};
  line-height: 16px;
  transition: 0.3s linear;
  background: #fff;
  padding: 5px 12px;
  color: ${({ trigger }) => (trigger ? "#17c95f" : "#989DA8")};
  font-weight: ${({ trigger }) => (trigger ? "700" : "")};
`;

const ErrorLabel = styled.label`
  position: absolute;
  font-size: 12px;
  bottom: -15px;
  left: 0px;
  line-height: 14px;
  transition: 0.3s linear;
  background: #ffffff00;
  color: rgb(255, 0, 0);
`;

const TextInput = (props) => {
  const prefix = props.prefix || "";
  const [inputStates, setInputStates] = useState({
    value: "",
    isActive: false,
    isFilled: false,
    isValid: false,
  });

  return (
    <InputWrapper>
      <Label for="input" trigger={inputStates.isActive || inputStates.isFilled}>
        {props.label}
      </Label>
      <Input
        {...props}
        id="input"
        type={props.type}
        trigger={inputStates.isActive || inputStates.isFilled}
        placeholder={props.placeholder ? props.placeholder : props.label}
        value={inputStates.value}
        onFocus={() => {
          props.onFocus();
          setInputStates({ ...inputStates, ...{ isActive: true } });
        }}
        onBlur={(event) => {
          if (event.target.value !== "") {
            setInputStates({
              ...inputStates,
              ...{ isActive: false, isFilled: true },
            });
          } else {
            setInputStates({
              ...inputStates,
              ...{ isActive: false, isFilled: false },
            });
          }
        }}
        onChange={(event) => {
          const input = event.target.value;
          props.onChange(event);
          event.target.value = prefix + input.substr(prefix.length);
          setInputStates({ ...inputStates, ...{ value: event.target.value } });
        }}
      />
      {props.showError && <ErrorLabel>{props.errorMessage}</ErrorLabel>}
    </InputWrapper>
  );
};

export default TextInput;
